module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n        Loss of Income to Date of Trial\n    ")]), _vm._v(" "), (_vm.pastLossTotal == 0) ? _c('div', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("\n        Claimant has no past loss of income.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.isLoading || _vm.pastLossPeriods == null
    }
  }), _vm._v(" "), (!_vm.isLoading && _vm.pastLossTotal) ? _c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.pastLossPeriods), function(period) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(period.period_from) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(period.period_to) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.duration_years, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.income_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.discounted_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.multiplier, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.value)) + "\n                    ")])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                        Total Loss of Income to Date of Trial:\n                    ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.pastLossTotal)) + "\n                        ")])])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("\n        Loss of Income and Pension Post-Trial & Lost Years\n    ")]), _vm._v(" "), (_vm.futureLossTotal == 0) ? _c('div', {
    staticClass: "a-form-inputs--error"
  }, [_vm._v("\n        Claimant has no loss of income post-trial or loss of income and/or pension in lost years.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.isLoading || _vm.futureLossPeriods == null
    }
  }), _vm._v(" "), (!_vm.isLoading && _vm.futureLossTotal) ? _c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        Dates (from–to)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Duration (years)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Deferment (years)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Income Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Discounted Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Multiplier\n                    ")]), _vm._v(" "), (_vm.claimant.income.contingencyMultiplier) ? _c('th', [_vm._v("\n                        Employment Contingency Multiplier\n                    ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("\n                        Total Loss of Income\n                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.futureLossPeriods), function(period, index) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(period.period_from) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(period.period_to) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.duration_years, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.deferment, 2)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.income_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.currencyFormat(period.discounted_multiplicand)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm.roundValue(period.multiplier, 2)) + "\n                    ")]), _vm._v(" "), (_vm.claimant.income.contingencyMultiplier) ? _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.claimant.income.multiplier, 2)))]) : _vm._e(), _vm._v(" "), _c('td', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0px"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.currencyFormat(period.value)) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "border": "none",
        "padding": "0 0 0 10px"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.toggleModal(period)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'calculation_' + _vm.uniqueId,
        "tooltip-text": "Click to view calculation",
        "side": "left",
        "text-width": "140",
        "icon-type": "formula"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right",
    attrs: {
      "colspan": _vm.claimant.income.contingencyMultiplier ? 8 : 7
    }
  }, [_vm._v("\n                        Total Loss of Income from Date of Trial to end of 'But For' Life Expectancy:\n                    ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("\n                            " + _vm._s(_vm.currencyFormat(_vm.futureLossTotal)) + "\n                        ")])])])])]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": true
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'calculation_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                        Dates (from–to)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Duration (years)\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Income Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Discounted Multiplicand\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Multiplier\n                    ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Total Loss of Income\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-303398d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lost-years-claims/steps/LossOfIncome.vue
// module id = 1627
// module chunks = 0